<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Support Us">
            <FormRow inline>
              <LazyCurrencySelector :currencies="['USD', 'ILS']" />
            </FormRow>
            <AmountSelector />
            <ErrorLabel field="amount" />
            <TransactionFee />
            <br />
            <InHonorOf />
          </FormSection>
          <FormSection title="Donation Frequency">
            <DonationFrequency />
          </FormSection>
          <FormSection title="Your Details">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow>
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow>
            <Receipt :receipts="['us', 'israel']"/>
          </FormRow>
          <br>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount btnText="Donate" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
::v-deep input#amount_other {
  margin-left: auto !important;
    font-size: 14px !important;
    padding-bottom: 0px !important;
    max-width: 227px !important;
    width: 100%;
}
</style>
